import $ from 'jquery';

const $win = $(window);
const $menuBtn = $('.header-mobile');
const $menuWrap = $('.menu-wrap');
const $header = $('#header');

let isHide = true;
let menuH;

function init() {
    $win.on('resize', () => {
        if ($menuBtn.css('display') === 'none') {
            $menuWrap.css('display', '');
        }
        
        $header.css('width', '100%');
        setTimeout(() => {
            $header.css('width', $win.width());
        }, 500);
    });

    $menuBtn.on('click', (e) => {
        e.preventDefault();
        if (isHide) {
            $menuWrap.css({ display: 'block', height: '' });
            menuH = $menuWrap.css('height');
            $menuWrap.css({ height: 0 });
            isHide = false;
            $menuWrap.stop(true).animate({ height: menuH });
        } else {
            isHide = true;
            $menuWrap.stop(true).animate({ height: 0 }, () => {
                $menuWrap.css({ display: 'none', height: '' });
            });
        }
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}